import { useMemo } from 'react';
import type { ODataGridColumn } from '@inuxe/prime-odata-grid';
import type { IHospitalRecordResult } from '../../../models/hospital/HospitalModel';
import HospitalFilesActionCell from './parts/HospitalFilesActionCell';

export function useHospitalFilesColumns(): ODataGridColumn<IHospitalRecordResult>[] {
  return useMemo<ODataGridColumn<IHospitalRecordResult>[]>(
    () => [
      {
        id: 'actions',
        header: 'İşlemler',
        sortable: false,
        filter: false,
        width: 120,
        className: 'grid-action-column',
        actionSticky: 'left',
        body: row => <HospitalFilesActionCell row={row} />,
      },
      {
        field: 'id',
        header: 'ID',
        dataType: 'numeric',
        width: 100,
        sortable: true,
        filter: true,
      },
      {
        field: 'tagNumberWithColor',
        header: 'Etiket No',
        minWidth: 130,
        sortable: false,
        filter: false,
      },
      {
        field: 'biomedicalDeviceDescription',
        header: 'Cihaz Tanımı',
        minWidth: 200,
        sortable: true,
        filter: true,
      },
      {
        field: 'brand',
        header: 'Marka',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'model',
        header: 'Model',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'serialNumber',
        header: 'Seri No',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'identificationNumber',
        header: 'Künye No',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'location',
        header: 'Lokasyon',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'addDate',
        header: 'Eklenme Tarihi',
        dataType: 'date',
        minWidth: 160,
        sortable: true,
        filter: true,
        body: row =>
          row.addDate ? new Date(row.addDate).toLocaleDateString('tr-TR') : '',
      },
      {
        field: 'note',
        header: 'Notlar',
        minWidth: 200,
        sortable: true,
        filter: true,
      },
      {
        field: 'hospitalName',
        header: 'Hastane',
        minWidth: 200,
        sortable: true,
        filter: true,
      },
      {
        field: 'responsiblePerson',
        header: 'Zimmetli Kişi',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
      {
        field: 'createdBy',
        header: 'Ekleyen Kişi',
        minWidth: 150,
        sortable: true,
        filter: true,
      },
    ],
    []
  );
}
